import { IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class GetValueAdditionDataBySkuCodesRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    skuCodeId: number;
    constructor(skuCodeId: number) {
        this.skuCodeId = skuCodeId;
    }
}